export const THRESHOLD_OPERATORS = [
  { value: 'FUERA', label: 'FUERA' },
  { value: 'OUTSIDE', label: 'OUTSIDE' },
  { value: 'OUT_OF_RANGE', label: 'OUT_OF_RANGE' },
  { value: 'RANGO', label: 'RANGO' },
  { value: 'DENTRO', label: 'DENTRO' },
  { value: 'INSIDE', label: 'INSIDE' },
  { value: 'IN_RANGE', label: 'IN_RANGE' },
  { value: 'BETWEEN', label: 'BETWEEN' },
  { value: '>', label: '>' },
  { value: '>=', label: '>=' },
  { value: '<', label: '<' },
  { value: '<=', label: '<=' }
];
